





































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState } from 'vuex'
import QuestionModel from '@/_models/QuestionModel'

@Component({
  components: {},
  computed: {},
})
export default class QuestionList extends Vue {
  // computed
  get questions(): QuestionModel[] {
    const questions = this.$store.state.questions.all.items
    return questions
  }

  get isLoading(): boolean {
    return this.$store.state.questions.loading
  }

  get filteredData(): QuestionModel[] {
    if (!this.questions) {
      return []
    }

    return this.questions
  }

  isInfo(type) {
    return type === 'info'
  }

  isImportant(type) {
    return type === 'important'
  }

  // After page created
  created() {
    this.$store.dispatch('questions/getAll')
  }
}
